const TIME_PERIODS = {
  TODAY:      'Today',
  THIS_WEEK:  'This Week',
  THIS_MONTH: 'This Month',
  LAST_MONTH: 'Last Month',
};

export default TIME_PERIODS;
